import { render } from "./account-check-detail.vue?vue&type=template&id=da9bd74e&scoped=true&ts=true"
import script from "./account-check-detail.vue?vue&type=script&lang=ts"
export * from "./account-check-detail.vue?vue&type=script&lang=ts"

import "./account-check-detail.vue?vue&type=style&index=0&id=da9bd74e&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9bd74e"]])

export default __exports__